(function ($, Drupal) {
  Drupal.behaviors.shoppableVideo = {
    attach: function (context, settings) {
      var $blocks = $('.js-shoppable-video-block', context);

      $blocks.each(function (i, obj) {
        var $block = $(obj);
        var $grid = $('.js-shoppable-video-grid', $block);
        var $mantle_cards = $('.js-mantle-video-card', $block);
        var $product_cards = $('.js-video-product-card', $block);
        var $cuepoint = $('.js-video-cuepoint', $block).first();
        var $videoblock = $('.js-videojs-video', $block);
        var num_cards = $product_cards.length;

        $cuepoint.addClass('hidden');
        $mantle_cards.each(function (i, obj) {
          var $card = $(obj);
          var $dots = $('.js-product-card-dots', $card);

          if ($dots.length == 0) {
            return;
          }
          var dots_dom = '';

          for (var k = 0; k < num_cards; k++) {
            if (i == k) {
              dots_dom += '<div class="video-product-card__dot active"></div>';
            } else {
              dots_dom += '<div class="video-product-card__dot"></div>';
            }
          }
          $dots.html($(dots_dom));
        });
        /*
         * Show now link activates the product grid, scroll down, and pauses
         * playing video.
         */
        $('.js-shop-now-link', $block).on('click', function (e) {
          e.preventDefault();
          $grid.toggleClass('active');
          if ($grid.length == 1 && $grid.hasClass('active')) {
            $cuepoint.trigger('cuepoint-pause-requested');
            $('html, body').animate({
              scrollTop: $grid.offset().top - 53
            }, 1000);
          }
        });
        $videoblock.on('click', function () {
          $cuepoint.removeClass('hidden');
        });
      });
    }
  };
})(jQuery, Drupal);
